import PDFViewer from '@/shared/PDFViewer'
import { useEffect, useRef, useState } from 'react'

const PDFViewerContainer = ({ document, style }) => {
  const pdfViewerContainerRef = useRef()

  const [containerWidth, setContainerWidth] = useState(0)

  useEffect(() => {
    const pdfContainerElement = pdfViewerContainerRef.current

    const pdfContainerObserver = new ResizeObserver(() => {
      const { clientWidth = 0 } = pdfContainerElement || {}
      setContainerWidth(clientWidth)
    })

    pdfContainerObserver?.observe(pdfContainerElement)

    return () => {
      pdfContainerObserver?.unobserve(pdfContainerElement)
    }
  }, [])

  return (
    <div
      ref={pdfViewerContainerRef}
      style={{
        maxWidth: '100%',
        height: '100%',
        overflowY: 'scroll',
        overflowX: 'hidden',
        ...style,
      }}
    >
      {document && <PDFViewer width={containerWidth}>{document}</PDFViewer>}
    </div>
  )
}

export default PDFViewerContainer
